<template>
 
  <!-- <vs-tr :data="item" :key="currentIndex" v-if="item.showMe && item.actionRequired">
    <vs-td class="td_name"
      ><b>{{ item.name }} </b>
    </vs-td>
    <vs-td class="names_wrap">

      <div v-if="['LCA_REQUEST','PAYMENT_INTEGRATION'].indexOf(item.code) < 0 ">
      <template v-for="(editor, ind) in item.editors">
        <em :key="ind" v-if="ind <= 1">{{ editor.roleName }}</em>
      </template>
      <div class="hiddenlist" v-if="item.editors.length > 2">
        <span>+{{ item.editors.length - 2 }}</span>
        <div class="hiddenlist_cnt">
          <ul>
            <template v-for="(editor, ind) in item.editors">
              <li :key="ind" v-if="ind > 1">{{ editor.roleName }}</li>
            </template>
          </ul>
        </div>
      </div>
 </div>
    </vs-td>
    <vs-td class="names_wrap">
      <div v-if="['LCA_REQUEST','PAYMENT_INTEGRATION'].indexOf(item.code) < 0 ">

      <template v-for="(editor, ind) in item.watchers">
        <em :key="ind" v-if="ind <= 1">{{ editor.roleName }}</em>
      </template>
      <div class="hiddenlist" v-if="item.watchers.length > 2">
        <span>+{{ item.watchers.length - 2 }}</span>
        <div class="hiddenlist_cnt">
          <ul>
            <template v-for="(editor, ind) in item.watchers">
              <li :key="ind" v-if="ind > 1">{{ editor.roleName }}</li>
            </template>
          </ul>
        </div>
      </div>
 </div>

    </vs-td>
  </vs-tr> -->

    <ul :data="item" :key="currentIndex" v-if="checkShowItem">
      <li class="activity">
        <div>
          <p :code="item.code">{{ item.name }} </p>

          <!---manageRfeCase-->
          <div  class="workflow-selected-list" v-if="item.code == 'UPDATE_USCIS_RESPONSE' && checkProperty(item, 'manageRfeCase') ">
            <span v-if="checkProperty(item, 'manageRfeCase')=='with_in_case'">Handle RFE Case With in the case.</span>
            <span v-else-if="checkProperty(item, 'manageRfeCase')=='filed_separately'">Handle RFE Case separately.</span>
          
          </div>

          <div  class="workflow-selected-list" v-if="item.code == 'COLLECT_ADV_EVIDENCE' ">
            <span v-if="item.approvedPwdReqForAdvEvidences=='Yes'">PWD Approval Required for collecting advertisement</span>
          
          </div>
         
          <!-----confirmRequired-->
          <template v-if="checkProperty(workflowDetailsData ,'workflowType') =='Free-Flow' && ['ASSIGN_SUPERVISOR','SUPERVISOR_LIST','ASSIGN_PARALEGAL','PARALEGAL_LIST','ASSIGN_DOCUMENTATION_MANAGER','DOCUMENTATION_MANAGER_LIST','ASSIGN_DOCUMENTATION_EXECUTIVE','DOCUMENTATION_EXECUTIVE_LIST'].indexOf(item.code) > -1">
            <div  class="workflow-selected-list" v-if=" checkProperty(item ,'confirmRequired')=='Yes'
               || checkProperty(item ,'confirmRequired')==true || ( item.code=='ASSIGN_SUPERVISOR' && ( checkProperty(item ,'canAssignAllUsers') ==true || checkProperty(item ,'canAssignAllUsers')=='Yes' ) )">
                <span >Confirmation Required. </span>

                <span v-if="( item.code=='ASSIGN_SUPERVISOR' && ( checkProperty(item ,'canAssignAllUsers') ==true || checkProperty(item ,'canAssignAllUsers')=='Yes' ) )">Can assign all users at once.</span>
             
            </div>

          </template>


          
          <div  class="workflow-selected-list" v-if="item.code == 'PREPARE_PERM_APPLICATION' && checkProperty(item ,'restrictPermDraftByAdvConfig')=='Yes'
           || checkProperty(item ,'restrictPermDraftByAdvConfig')==true">
            <span >Allow PERM creation after the cooling period from the date of last advertisement. </span>
          
        </div>
        

          <template  v-if="item.code == 'CREATE_INVOICE' " >
          <!-----FILE_AFTER_INVOICE  FILE_AFTER_INVOICE_PAYMENT-->
          <div class="workflow-selected-list" v-if="getActivityText('FILE_AFTER_INVOICE') || getActivityText('FILE_AFTER_INVOICE_PAYMENT')">
            <span v-if="getActivityText('FILE_AFTER_INVOICE')">
             {{getActivityText('FILE_AFTER_INVOICE')}}
             </span>

             <span v-if="getActivityText('FILE_AFTER_INVOICE_PAYMENT')"> {{getActivityText('FILE_AFTER_INVOICE_PAYMENT')}} </span>
          </div>
        
          

          </template>
        </div>
      </li>
      <li class="editors">
        
           <div v-if="['PAYMENT_INTEGRATION'].indexOf(item.code) < 0 ">
      <template v-for="(editor, ind) in item.editors">
        <em :key="ind" v-if="ind <= 1">{{ editor.roleName }}</em>
      </template>
      <div class="hiddenlist" v-if="item.editors.length > 2">
        <span>+{{ item.editors.length - 2 }}</span>
        <div class="hiddenlist_cnt">
          <ul>
            <template v-for="(editor, ind) in item.editors">
              <li :key="ind" v-if="ind > 1">{{ editor.roleName }}</li>
            </template>
          </ul>
        </div>
      </div>
 
        </div>
      </li>
      <li  class="watchers">
         
          <div v-if="['LCA_REQUEST','PAYMENT_INTEGRATION'].indexOf(item.code) < 0 ">
              <template v-for="(editor, ind) in item.watchers">
                <em :key="ind" v-if="ind <= 1">{{ editor.roleName }}</em>
              </template>
              <div class="hiddenlist" v-if="item.watchers.length > 2">
                <span>+{{ item.watchers.length - 2 }}</span>
                <div class="hiddenlist_cnt">
                  <ul>
                    <template v-for="(editor, ind) in item.watchers">
                      <li :key="ind" v-if="ind > 1">{{ editor.roleName }}</li>
                    </template>
                  </ul>
                </div>
              </div>
        </div>
         
      </li>  
    </ul>
 
</template>

<script>
import * as _ from "lodash";

export default {

  data: () => ({
    requestLCA: ["LCA_REQUEST"],
    submitLCA: ["LCA_SUBMIT"],
  }),
  props: {
    currentStep: {
      type: Number,
    },
    userRolesList: {
      type: Array,
    },
    item: {
      type: Object,
    },
    currentIndex: {
      type: Number,
    },
    activityList: {
      type: Array,
    },
    workflowDetailsData:null
  },
  methods: {
     hideOption(item) {
       if(item.code == 'ASSIGN_SUPERVISOR'){
          return true;
       }
      if (this.submitLCA.indexOf(item.code) > -1) {
        var _findlcaRequest = _.find(this.activityList, {
          code: "LCA_REQUEST",
        });
        if (!_findlcaRequest.actionRequired) {
          return false;
        }
      }
      if(item.actionRequired){
        return true;
      }
      return false;
    },
  },
  computed:{
    checkShowItem(){
      let isShow = this.checkProperty(this.item, 'showMe') && this.hideOption(this.item) && ['FILE_AFTER_INVOICE',  'FILE_AFTER_INVOICE_PAYMENT'].indexOf(this.item.code)<=-1

      if( ['RFE_PREPARE_RESPONSE_DOCS','RFE_CASE_APPROVED','RFE_DOC_SIGNER_LIST','RFE_REQUEST_PETITIONER_SIGN','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.item.code) >-1  && ['filed_separately'].indexOf( this.checkProperty(this.workflowDetailsData, 'manageRfeCase') )>-1 ){
        isShow =false;
      }
      return isShow;
    },
    getActivityText(){
      
     return (activityCode)=>{
      let returnVal='';
        if(activityCode){
          let activityItem = _.find(this.activityList ,{'code':activityCode})
          if(activityItem && this.checkProperty(activityItem ,'name') && (this.checkProperty(activityItem ,'actionRequired')==true || this.checkProperty(activityItem ,'actionRequired')=='Yes' ) ){
            returnVal = activityItem['name'];
          }

        }
        return returnVal;
      }
    }
  }
};
</script>